import script from "./SectionEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./SectionEditModal.vue?vue&type=style&index=0&id=43a0b415&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43a0b415"]])

export default __exports__